import AppIcon from "./AppIcon.vue";
export default AppIcon;
